import { render } from "./DocTabletIcon.vue?vue&type=template&id=d06f9c8e"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/DocTabletIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d06f9c8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d06f9c8e', __exports__)) {
    api.reload('d06f9c8e', __exports__)
  }
  
  module.hot.accept("./DocTabletIcon.vue?vue&type=template&id=d06f9c8e", () => {
    api.rerender('d06f9c8e', render)
  })

}


export default __exports__